module.exports = __webpack_public_path__ + "img/visa.8b42fdd8.svg";